import { useEffect, useState } from "react";
import HexCard from "../components/HexCard";
import { api } from "../lib/api";
import { AFFILIATES_PLACEHOLDER } from "../lib/assets";
import { resolveUploadUrl } from "../components/ImageUploadField";

export default function AffiliatesPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/affiliates")
      .then((r) => setItems(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-12 py-16 lg:py-24" data-testid="affiliates-page">
      <header className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end mb-16">
        <div className="lg:col-span-7 warm-up">
          <span className="label-accent">// Mesh</span>
          <h1 className="broadcast-headline text-5xl lg:text-7xl mt-4 text-[color:var(--nccc-cream)] chromatic">
            Affiliates
          </h1>
          <p className="mt-6 text-[color:var(--nccc-muted)] max-w-xl">
            Allied labels, venues, artists and collectives. The wider network —
            a Northern mesh held together by shared resources and shared
            refusal.
          </p>
        </div>
        <div className="lg:col-span-5 lg:col-start-8 label warm-up-2">
          <p>NODES // {items.length || "—"} ACTIVE</p>
        </div>
      </header>

      {loading ? (
        <p className="label">// mapping the mesh...</p>
      ) : items.length === 0 ? (
        <p className="label">// no nodes listed.</p>
      ) : (
        <>
          <div className="honeycomb">
            {items.map((a) => (
              <HexCard
                key={a.id}
                testid={`hex-card-affiliate-${a.id}`}
                imageUrl={resolveUploadUrl(a.image_url) || AFFILIATES_PLACEHOLDER}
                eyebrow={a.kind?.toUpperCase()}
                title={a.name}
                subtitle={a.region}
                href={a.link_url || undefined}
              />
            ))}
          </div>
          <div className="honeycomb-spacer" />
        </>
      )}
    </div>
  );
}
